import * as React from 'react';
import { Alert } from '@mui/material';
import Common from '../utilities/common';
import $ from "jquery";

export interface IDataCheckerProps {
    field: string;
    errorMessage: string;
    onHasErrors: any;
    icon?: string | JSX.Element | JSX.Element[];
}

export interface IDataCheckerState {
    difference: number;
}

export default class DataChecker extends React.Component<IDataCheckerProps, IDataCheckerState> {
    public constructor(props: IDataCheckerProps) {
        super(props);

        this.state = {
            difference: -1
        }
    }

    componentDidMount(): void {
        this.Get();
    }

    public render(): React.ReactElement<{}> {
        return (
            <React.Fragment>
                {
                    this.state.difference > 0 && (
                        <Alert severity="error" icon={this.props.icon} style={{marginBottom: '10px'}}>
                            {
                                this.props.errorMessage.replace('{0}', this.state.difference.toString())
                            }
                        </Alert>
                    )
                }
            </React.Fragment>
        )
    }

    private Get(): void {
        let url = `${Common.END_POINT}/data/check/${this.props.field}`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: number) => {
            this.setState(
                {
                    difference: response
                }
            );

            if(response > 0) {
                this.props.onHasErrors();
            }

        });
    }
}